import { OPEN_MOBILE_CHILD_LINKS_NAV_ATTR } from '../../../scripts/config/constants';

export const initThemeMobileNavigation = () => {
  const childLinksSelector = 'data-theme-mobile-navigation-screen-child-links';
  const parentLinksSelector = 'data-theme-mobile-navigation-screen-base-link';
  const mobileNavsParent = document.querySelector(
    '[data-theme-mobile-navigation-parent]'
  );
  const parentLinks = document.querySelectorAll(`[${parentLinksSelector}]`);
  const childLinks = document.querySelectorAll(`[${childLinksSelector}]`);

  parentLinks.forEach((parentLink) => {
    parentLink.addEventListener('click', () => {
      const targetMainLink = parentLink.getAttribute(`${parentLinksSelector}`);
      const activeChildLink = document.querySelector(
        `[${childLinksSelector}='${targetMainLink}']`
      );

      childLinks.forEach((childLink) => {
        childLink.setAttribute('data-active', 'false');
      });

      activeChildLink.setAttribute('data-active', 'true');
      mobileNavsParent.scrollTo({
        top: 0,
      });
      document.body.setAttribute(OPEN_MOBILE_CHILD_LINKS_NAV_ATTR, 'true');
    });
  });
};
